import React from 'react';
import isUndefindedOrNull from '../../Common/utils/isUndefinedOrNull';

const Heading = (props) => {
    const { content, otherBuses=false } = props;
    const result = isUndefindedOrNull(content)

    return (
        result ? <></> :
            <div className="seoHeading">
              {!otherBuses ?   <h1>{content}</h1> : <h2>{content}</h2>}
            </div>
    )
}

export default Heading;
